import { toast } from 'vue3-toastify'

export function __(key, domain) {
    return mareike_i18n[key] || key;
}
export function _mareike_nonce() {
    return mareike_user + '|' + mareike_nonce;
}
export function _mareike_download_as_zip() {
    return mareike_download_as_zip === 'true';
}

export function _mareike_use_webdav() {
    return mareike_use_webdav === 'true';
}


export function mareike_check_filesize(field_id) {
    if (document.getElementById(field_id).files[0].size <= mareike_max_size_mb * 1024 * 1024) {
        return true;
    } else {
        alert($max_upload_size_too_low);
        return false;
    }
}

export function _mareike_user_is_admin() {
    return mareike_user_is_admin === 'true';
}

export function mareike_is_valid_iban(iban_identifier) {
    var iban = document.getElementById( iban_identifier ).value;
    iban = iban.replace( /\s+/g, '' ).toUpperCase();

    if (iban.length !== 22) {
        return false;
    }

    if ( ! iban.startsWith( 'DE' )) {
        return false;
    }

    iban = iban.slice( 4 ) + iban.slice( 0, 4 );

    const convertedIban = iban.split( '' ).map(
        char => {
            const code  = char.charCodeAt( 0 );
            return code >= 65 && code <= 90 ? (code - 55).toString() : char;
        }
    ).join( '' );

    let remainder = convertedIban;
    while (remainder.length > 2) {
        const block = remainder.slice( 0, 9 );
        remainder   = (parseInt( block, 10 ) % 97).toString() + remainder.slice( 9 );
    }

    return parseInt( remainder, 10 ) % 97 === 1;
}

export function mareike_is_valid_email(email) {
    // Einfache RegEx, um eine E-Mail-Adresse zu validieren
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Teste die E-Mail-Adresse gegen die RegEx
    return emailRegex.test( email );
}



export function notify(message, type) {


    toast(message, {
        "theme": "colored",
        "type": type,
        "position": "bottom-right",
        "transition": "slide",
        "dangerouslyHTMLString": true

    })
}
